import React, { FC, useCallback, useEffect, useState } from "react";

import Layout from "../components/Layout/System";

import NavbarMain from "../components/Navigation/Navbar/Main";
import SidebarMain from "../components/Navigation/Sidebar/Main";
import StatusbarMain from "../components/Navigation/Status/Main";

import NavbarSystem from "../components/Navigation/Navbar/System";
import SidebarSystem from "../components/Navigation/Sidebar/System";
import SidebarSystemPlan from "../components/Navigation/Sidebar/SystemPlan";
import StatusbarSystem from "../components/Navigation/Status/System";

import NavbarReports from "../components/Navigation/Navbar/Reports";
import NavbarSettings from "../components/Navigation/Navbar/Settings";

import SystemList from "../components/System/SystemList";

//import { systems } from '../data/systems';
import ButtonContainer from "../components/ButtonContainer/ButtonContainer";
import EventOverview from "../components/Event/EventOverview/EventOverview";

import GroupOverview from "../components/Group/GroupOverview/GroupOverview";
import { useNamedRoutes } from "../components/NamedRoutes";
import Plan from "../components/Plan/Plan";
import AnalogueValues from "../components/System/Reports/AnalogueValues/AnalogueValues";
import EventMemory from "../components/System/Reports/EventMemory/EventMemory";
import MaintenanceReport from "../components/System/Reports/MaintenanceReport/MaintenanceReport";
import PhoneNumbers from "../components/System/Reports/Phonenumbers/Phonenumbers";
import ShareSettingsOverlay from "../components/System/Reports/Shares/Component/Settings/SettingsOverlay";
import Shares from "../components/System/Reports/Shares/Shares";
import Details from "../components/System/SystemDetails";
import SettingsOverlay from "../components/System/SystemSettings/SettingsOverlay/SettingsOverlay";

import
{
  useRedirectIfSystemUnavailable,
  useSystem,
  useSystemDetails,
  useSystemMaintenance,
  useSystemRTM,
  useSystemSetup,
} from "../components/ReactData/system";

import NewSystemModal from "../components/System/NewSystem/NewSystemModal";
//import PermissionModal from '../components/System/Permission/PermissionModal';
import { useL10n } from "@ews/react-localization-context";
import { MenuLink } from "../components/Navigation/Sidebar/Sidebar";
import type { MenuToggleProps } from "../components/Navigation/types";
import DocumentationsSettingsOverlay from "../components/System/DocumentationsSettings/DocumentationsSettings/DocumentationsSettingsOverlay";
import DisplayDevice from "../components/System/Reports/DisplayDevice/DisplayDevice";
import InputsSystemDocumentation from "../components/System/Reports/InputsSystemDocumentation/InputsSystemDocumentation";
import OtherAlarmDevices from "../components/System/Reports/OtherAlarmDevices/OtherAlarmDevices";
import OtherDevices from "../components/System/Reports/OtherDevices/OtherDevices";
import PowerUnitsDocumentation from "../components/System/Reports/PowerUnitsDocumentation/PowerUnitsDocumentation";
import DocumentationHistory from "../components/System/Reports/SystemDocumentationHistory/SystemDocumentationHistory";
import TypeDefinitionSubmissionDocuments from "../components/System/Reports/TypeDefinitionSubmissionDocuments/TypeDefinitionSubmissionDocuments";
import type { ReactClickEvent } from "../components/types";

import { Pane, PaneSection } from "../components/Layout/Pane";

import
{
  RTMDisplay,
  UserPermissions,
  permissionAllowed,
} from "@ews/react-data";
import Icon from "@ews/react-icons";
import { AuthorizationLevel, NumberGroup } from "@ews/zlt-events";
import { IonButton } from "@ionic/react";
import { useAuthorization } from "../components/Authorization";
import type { FilterButton, FilterState } from "../components/FilterList/types";
import { useMyPermissions } from "../components/Login/LoginProvider";
import { usePersistentState } from "../components/Persistence";
import { useCustomer } from "../components/ReactData/customer";
import { useUser } from "../components/ReactData/user";
import { useIsMobile } from "../components/Responsive";
import
{
  ElementInfo,
  getElementLogicalAddressText,
} from "../components/System/Reports/MaintenanceReport/components/MaintenanceSetting/ElementInfo";
import SystemDocumentation from "../components/System/Reports/SystemDocumentation/SystemDocumentation";
import ElementList from "../components/System/Reports/SystemElementList/SystemElementList";
import SentTextMessagesLog from "../components/System/SentTextMessagesLog/SentTextMessagesLog";
import SystemSelect from "../components/System/SystemSelect";
import { T_GROUP_LIST } from "../components/System/SystemSettings/types"; // TODO: a const is NOT a type
import SpecificationsOverlay from "../components/System/SystemSpecifications/SpecificationsOverlay";
import { setTitle } from "../utils";



/*
TODO: schauen warum sich die Navbar bei SystemDetails, SystemElement, SystemEvent und SystemPlan ständig kurz verschwindet und wieder rendert
*/


export type FilterProps = {
  filter?: FilterState,
  onIsOpen?: (status: boolean, type: "detail" | "main") => void;
  onFilterActive?: (status: boolean) => void;
};

const SidebarWrapper: FC<MenuToggleProps> = ({ onMenuToggle }) =>
{
  const { translate: t } = useL10n();
  const permissions: UserPermissions = useMyPermissions();


  return (
    <SidebarMain onMenuToggle={onMenuToggle}>
      {permissionAllowed(permissions.grantSystemAccess!) ? (
        <>
          <MenuLink
            title={t("COM_FACPMANAGEMENT_CUSTOMERS_CREATE_SYSTEM")}
            id="newSystem"
            icon={<Icon icon="systems_create" />}
          />
          <NewSystemModal
            trigger="newSystem"
            onDismiss={(e) =>
              onMenuToggle && onMenuToggle(e as unknown as ReactClickEvent)
            }
          />
        </>
      ) : (
        <></>
      )}
    </SidebarMain>
  );
};

const System: React.FC<{ filterByCustomer?: boolean; }> = ({
  filterByCustomer,
}) =>
{
  const { params } = useNamedRoutes();
  const { id: customerId } = params();
  const customer = useCustomer(customerId || "");

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const [view, setView] = useState<"list" | "map">("list");
  const toggle = useCallback(() =>
  {
    setView(view === "list" ? "map" : "list");
  }, [view]);

  const permissions = useMyPermissions();
  const { translate: t } = useL10n();

  useEffect(() =>
  {
    setTitle(`${t("COM_FACPMANAGEMENT_FACP_MANAGER_FIREALARMPANELS")}`);
  }, [t]);

  const StatusbarWithToggleListMapButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarMain
          buttons={[
            <IonButton
              size="small"
              color={"primary"}
              shape="round"
              fill="solid"
              onClick={toggle}
            >
              <Icon
                width={18}
                height={18}
                icon={view === "list" ? `map_view` : `list`}
              />
            </IonButton>,
          ]}
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState.isFilterActive, FilterState.isFilterOpen, onFilterOpen, toggle, view]);

  const canListAllSystems = ("listAllSystems" in permissions) && permissionAllowed(permissions.listAllSystems!);

  return <>
    <Layout
      sidebar={SidebarWrapper}
      statusbar={StatusbarWithToggleListMapButton}
      navbar={NavbarMain}
      id="system"
      header={false}
    >
      {
        !("listAllSystems" in permissions) || (filterByCustomer && !("tree" in customer)) ?
          <></> :
          <>
            {canListAllSystems ?
              <SystemList
                type={view}
                customerTree={filterByCustomer ? customer.tree : undefined}
                filter={FilterState}
                onIsOpen={onIsOpen}
                onFilterActive={onFilterIsActive}
              /> :
              <SystemSelect />
            }
          </>
      }
    </Layout>
    {/*  ) : (
        <Layout
          sidebar={SidebarWrapper}
          statusbar={StatusbarMain}
          navbar={NavbarMain}
          id="system"
          header={false}
        >

        </Layout>
      )} */}
  </>;
};

const SystemEvent: React.FC<{
  eventTab?: RTMDisplay;
}> = ({ eventTab = RTMDisplay.eventsTab1 }) =>
  {
    const { params } = useNamedRoutes();
    const { id } = params();

    const system = useSystem(id!);
    useRedirectIfSystemUnavailable(id!);
    const rtm = useSystemRTM(id!);

    const { translate: t } = useL10n();

    setTitle(
      `${t("[SID_MNU_HK_EVENTS]")}${eventTab === RTMDisplay.eventsTab2 ? " 2" : ""}`,
      `${system.name}`,
      `[${system.systemNumber!}]`
    );

    const [FilterState, setFilterState] = usePersistentState<FilterState>('system-event-page:filter', {} as FilterState);

    const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
    {
      setFilterState((pre) =>
      {
        const obj: Partial<Record<keyof FilterState, boolean>> = {};

        if (type === "detail") {
          obj.isDetailOpen = state;
        }
        else {
          obj.isFilterOpen = state;
        }

        return { ...pre, ...obj };

      });

    }

      , [setFilterState]);

    const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
    {
      setFilterState((pre) => ({ ...pre, isFilterOpen }));
    }, [setFilterState]);

    const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
    {
      if (FilterState.isFilterActive !== isFilterActive) {
        setFilterState((pre) => ({ ...pre, isFilterActive }));
      }
    }, [FilterState?.isFilterActive, setFilterState]);


    const Bar = useCallback(() =>
    {
      return (
        <>
          <StatusbarSystem
            filter
            isFilterOpen={FilterState.isFilterOpen}
            activeFilter={FilterState.isFilterActive}
            onFilterOpen={onFilterOpen}
          />
        </>
      );
    }, [FilterState.isFilterActive, FilterState.isFilterOpen, onFilterOpen]);

    return (
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        system={system}
        statusbar={Bar}
        sidebar={SidebarSystem}
        navbar={NavbarSystem}
        id="system:events"
      >
        <Pane vertical>
          <PaneSection grow>
            <EventOverview
              eventTab={eventTab}
              rtm={rtm}
              filter={FilterState}
              onIsOpen={onIsOpen}
              onFilterActive={onFilterIsActive}
            />
          </PaneSection>
          <PaneSection>
            <ButtonContainer systemId={system.id || ""} rtm={rtm} />
          </PaneSection>
        </Pane>
      </Layout>
    );
  };

const SystemDetails: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();

  const system = useSystem(id!);
  const details = useSystemDetails(id!);
  useRedirectIfSystemUnavailable(id!);
  const rtm = useSystemRTM(id!);
  const { translate: t } = useL10n();

  setTitle(
    `${t("COM_FACPMANAGEMENT_LOGS_EVENTS_DETAILS")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      system={system}
      statusbar={StatusbarSystem}
      sidebar={SidebarSystem}
      navbar={NavbarSystem}
      id="system:system"
    >
      <Pane vertical>
        <PaneSection grow>
          <Details system={system!} details={details!} />
        </PaneSection>
        <PaneSection>
          <ButtonContainer systemId={system.id || ""} rtm={rtm} />
        </PaneSection>
      </Pane>
    </Layout>
  );
};

const SystemGroup: React.FC = () =>
{
  const { params, router, generate } = useNamedRoutes();
  const { id } = params();

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-group-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const system = useSystem(id!);
  const setup = useSystemSetup(id!);
  useRedirectIfSystemUnavailable(id!);
  const rtm = useSystemRTM(id!);

  const permissions = useMyPermissions();
  const { authorizationLevel } = useAuthorization();
  const { translate: t } = useL10n();


  const Bar = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState.isFilterActive, FilterState.isFilterOpen, onFilterOpen]);


  if (!permissions.listViewAccessLevel1 && authorizationLevel <= AuthorizationLevel.LEVEL1) {
    // Ticket #12315: redirect to details if user is not authorized
    if (!permissions.notReadyFlag) {
      const redirect = generate('system', { id });
      router?.push(redirect);
    }
    return <></>;
  }

  setTitle(
    `${t("[REACT_ELEMENTS]")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );


  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      system={system}
      statusbar={Bar}
      sidebar={SidebarSystem}
      navbar={NavbarSystem}
      id="system:elements"
    >
      {!permissions.listViewAccessLevel1 && authorizationLevel <= AuthorizationLevel.LEVEL1 ?
        <></> :

        <Pane vertical>
          <PaneSection grow>
            <GroupOverview
              filter={FilterState}
              onIsOpen={onIsOpen}
              onFilterActive={onFilterIsActive}
              groups={setup.groups || []}
            />
          </PaneSection>
          <PaneSection>
            <ButtonContainer systemId={system.id || ""} rtm={rtm} />
          </PaneSection>
        </Pane>
      }
    </Layout>
  );
};

const SystemElementComment: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id, numberGroup, group, element } = params();
  const { translate: t } = useL10n();

  const system = useSystem(id!);
  setTitle(`${t("[REACT_COMMENT]")}`);

  const maintenanceSettings = useSystemMaintenance(id || "");

  const T_GROUP = t(
    T_GROUP_LIST[
    (Number(numberGroup) || NumberGroup.Zone) as keyof typeof T_GROUP_LIST
    ] || ""
  );

  const title = getElementLogicalAddressText(
    Number(group || 0),
    Number(element || 0),
    Number(numberGroup || 0),
    T_GROUP,
    maintenanceSettings.formatLeadingZeros || false
  );

  return (
    <>
      <Layout
        title={title}
        backbutton={true}
        system={system}
        statusbar={StatusbarMain}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:element-comment"
      >
        {numberGroup && group && element ? (
          <ElementInfo
            numberGroup={numberGroup}
            group={group}
            element={element}
            systemId={id}
          />
        ) : (
          <></>
        )}
      </Layout>
    </>
  );
};

const SystemPlan: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  const rtm = useSystemRTM(id!);
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);
  const { translate: t } = useL10n();

  setTitle(
    `${t("TD_PLAN")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      system={system}
      statusbar={StatusbarSystem}
      sidebar={SidebarSystemPlan}
      navbar={NavbarSystem}
      id="system:plan"
    >
      <Pane vertical>
        <PaneSection grow>
          <Plan system={system!} />
        </PaneSection>
        <PaneSection>
          <ButtonContainer systemId={system.id || ""} rtm={rtm} />
        </PaneSection>
      </Pane>
    </Layout>
  );
};

const SystemShares: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-share-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);
  const { translate: t } = useL10n();

  setTitle(
    `${t("[REACT_SYSTEM_SHARES]")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:shares"
      >
        <Shares
          system={system!}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};

const SystemShareSettings: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id, userId } = params();

  const system = useSystem(id!);
  const user = useUser(userId || "");
  useRedirectIfSystemUnavailable(id!);
  const { translate: t } = useL10n();
  setTitle(
    `${t("[REACT_SYSTEM_SHARES]")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  return (
    <>
      <Layout
        title={
          system.id
            ? `[${system.systemNumber!}] ${system.name}${user.id ? `, ${`[${user.username!}] ${user.firstName} ${user.lastName}`}` : ""}`
            : ``
        }
        backbutton={true}
        system={system}
        statusbar={StatusbarMain}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:share-settings"
      >
        <ShareSettingsOverlay systemId={id} userId={userId} />
      </Layout>
    </>
  );
};

const SystemEventMemory: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-event-memory-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);
  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);
  const { translate: t } = useL10n();

  setTitle(
    `${t("COM_FACPMANAGEMENT_FACP_MEMORY_BREADCRUMB")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      statusbar={StatusbarFilterButton}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:eventmemory"
    >
      <EventMemory
        filter={FilterState}
        onIsOpen={onIsOpen}
        onFilterActive={onFilterIsActive}
        system={system!}
      />
    </Layout>
  );
};

const SystemAnalogueValues: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);
  const { translate: t } = useL10n();

  setTitle(
    `${t("[REACT_MEASURES]")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-analoguevalues-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);
  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      statusbar={StatusbarFilterButton}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:analoguevalues"
    >
      <AnalogueValues
        filter={FilterState}
        onIsOpen={onIsOpen}
        onFilterActive={onFilterIsActive}
        system={system!}
      />
    </Layout>
  );
};

const SystemMaintenanceReport: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);


  const system = useSystem(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-maintenance-page:filter', {} as FilterState);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);

  const { translate: t } = useL10n();
  setTitle(
    `${t("COM_FACPMANAGEMENT_USER_ACCOUNT_MAINTENANCE")}`,
    `${system.name}`,
    `[${system.systemNumber!}]`
  );

  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);


  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      statusbar={StatusbarFilterButton}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:maintenancereport"
    >
      <MaintenanceReport
        system={system!}
        filter={FilterState}
        onIsOpen={onFilterOpen}
        onFilterActive={onFilterIsActive}
      />
    </Layout>
  );
};

// const SystemQueries: React.FC = () =>
// {
//     const {params} = useNamedRoutes();
//     const {id} = params();

//     const system = useSystem(id!);

//     return (
//         <>
//             <Layout
// backbutton={true} system={system} statusbar={StatusbarMain} sidebar={SidebarSystem} navbar={NavbarReports} id="system:queries">
//                 <Queries system={system!} />
//             </Layout>
//         </>
//     );
// };

const SystemPhoneNumber: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-phone-number-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      statusbar={StatusbarFilterButton}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:phonenumber"
    >
      <PhoneNumbers
        system={system!}
        filter={FilterState}
        onIsOpen={onIsOpen}
        onFilterActive={onFilterIsActive}
      />
    </Layout>
  );
};

const SystemDocumentationHistory: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-documentation-history-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      statusbar={StatusbarFilterButton}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:Documentation-history"
    >
      <DocumentationHistory
        system={system!}
        filter={FilterState}
        onIsOpen={onIsOpen}
        onFilterActive={onFilterIsActive}
      />
    </Layout>
  );
};

const SystemDisplayDevice: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-displayDevice-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:displaydevice"
      >
        <DisplayDevice
          system={system!}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};
const SystemPowerUnitsDocumentation: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [filter, setFilter] = useState<FilterButton>({
    buttonPressed: false,
    isOpen: false,
    active: false,
  });

  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={filter.isOpen}
          activeFilter={filter.active}
          onFilterOpen={(state) =>
          {
            setFilter({ ...filter, buttonPressed: true, isOpen: state });
          }}
        />
      </>
    );
  }, [filter, setFilter]);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:powerunitsdocumentation"
      >
        <PowerUnitsDocumentation
          systemId={system.id!}
          filter={filter}
          onIsOpen={(isOpen, buttonPressed, active) =>
            setFilter({ ...filter, isOpen, buttonPressed, active })
          }
        />
      </Layout>
    </>
  );
};

const SystemElementList: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();

  useRedirectIfSystemUnavailable(id!);

  const [filter, setFilter] = useState<FilterButton>({
    buttonPressed: false,
    isOpen: false,
    active: false,
  });

  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          filter
          isFilterOpen={filter.isOpen}
          activeFilter={filter.active}
          onFilterOpen={(state) =>
          {
            setFilter({ ...filter, buttonPressed: true, isOpen: state });
          }}
        />
      </>
    );
  }, [filter, setFilter]);

  const system = useSystem(id!);
  const isMobile = useIsMobile();
  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:elementlist"
      >
        <ElementList
          systemId={system.id!}
          filter={{ ...filter, isOpen: !isMobile }}
          onIsOpen={(isOpen, buttonPressed) =>
            setFilter({ ...filter, isOpen, buttonPressed })
          }
        />
      </Layout>
    </>
  );
};

const SystemOtherAlarmDevices: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-other-alarm-devices-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:otheralarmdevices"
      >
        <OtherAlarmDevices
          system={system!}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};

const SystemOtherDevices: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarMain}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:otherdevices"
      >
        <OtherDevices system={system!} />
      </Layout>
    </>
  );
};
const SystemInputsSystemDocumentation: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-inputs-system-documentation-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarSystem
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:inputssystemDocumentation"
      >
        <InputsSystemDocumentation
          system={system!}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};

const SystemDocumentationsSettingsOverlay: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarMain}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:Documentationhistory"
      >
        <DocumentationsSettingsOverlay system={system!} />
      </Layout>
    </>
  );
};

const SystemSpecificationsOverlay: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);
  /* return system?.id ? <Layout
    backbutton={true} system={system} sidebar={SidebarSystem} navbar={NavbarSettings} id="system:settings">

                                                <SettingsOverlay systemId={system.id || ""} />
                                            </Layout> : <></>; */
  return system?.id ? (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      sidebar={SidebarSystem}
      navbar={NavbarReports}
      id="system:specifications"
    >
      <SpecificationsOverlay systemId={system.id || ""} />
    </Layout>
  ) : (
    <></>
  );
};

const SystemDocumentationOverlay: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();

  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarMain}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:Documentationhistory"
      >
        <SystemDocumentation systemId={system?.id} />
      </Layout>
    </>
  );
};

const SystemSentTextMessagesLogOverlay: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-sent-text-messages-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);

  const StatusbarFilterButton = useCallback(() =>
  {
    return (
      <>
        <StatusbarMain
          filter
          isFilterOpen={FilterState.isFilterOpen}
          activeFilter={FilterState.isFilterActive}
          onFilterOpen={onFilterOpen}
        />
      </>
    );
  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);
  const { translate: t } = useL10n();

  setTitle(`${t("[REACT_SEND_TEXT_LOGS]")}`);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:sentTextMessagesLog"
      >
        <SentTextMessagesLog
          systemId={system?.id}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};

const SystemTypeDefinitionSubmissionDocuments: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const [FilterState, setFilterState] = usePersistentState<FilterState>('system-type-definition-submission-documents-page:filter', {} as FilterState);

  const onIsOpen = useCallback((state: boolean, type: "detail" | "main") =>
  {
    setFilterState((pre) =>
    {
      const obj: Partial<Record<keyof FilterState, boolean>> = {};

      if (type === "detail") {
        obj.isDetailOpen = state;
      }
      else {
        obj.isFilterOpen = state;
      }

      return { ...pre, ...obj };

    });

  }

    , [setFilterState]);

  const onFilterOpen = useCallback((isFilterOpen: boolean,) =>
  {
    setFilterState((pre) => ({ ...pre, isFilterOpen }));
  }, [setFilterState]);

  const onFilterIsActive = useCallback((isFilterActive: boolean,) =>
  {
    if (FilterState.isFilterActive !== isFilterActive) {
      setFilterState((pre) => ({ ...pre, isFilterActive }));
    }
  }, [FilterState?.isFilterActive, setFilterState]);


  const StatusbarFilterButton = useCallback(() =>
  {
    return <StatusbarSystem
      isFilterOpen={FilterState.isFilterOpen}
      activeFilter={FilterState.isFilterActive}
      onFilterOpen={onFilterOpen}
    />;

  }, [FilterState, onFilterOpen]);

  const system = useSystem(id!);

  return (
    <>
      <Layout
        title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
        backbutton={true}
        system={system}
        statusbar={StatusbarFilterButton}
        sidebar={SidebarSystem}
        navbar={NavbarReports}
        id="system:typedefinition-submission-documents"
      >
        <TypeDefinitionSubmissionDocuments
          system={system!}
          filter={FilterState}
          onIsOpen={onIsOpen}
          onFilterActive={onFilterIsActive}
        />
      </Layout>
    </>
  );
};

const SystemSettings: React.FC = () =>
{
  const { params } = useNamedRoutes();
  const { id } = params();
  useRedirectIfSystemUnavailable(id!);

  const system = useSystem(id!);

  return system?.id ? (
    <Layout
      title={system.id ? `[${system.systemNumber!}] ${system.name}` : ""}
      backbutton={true}
      system={system}
      sidebar={SidebarSystem}
      navbar={NavbarSettings}
      id="system:settings"
    >
      <SettingsOverlay systemId={system.id || ""} />
    </Layout>
  ) : (
    <></>
  );
};

export
{
  System,
  SystemAnalogueValues,
  SystemDetails,
  SystemDisplayDevice,
  SystemDocumentationHistory,
  SystemDocumentationOverlay,
  SystemDocumentationsSettingsOverlay,
  SystemElementComment, SystemElementList, SystemEvent,
  SystemEventMemory,
  SystemGroup,
  SystemInputsSystemDocumentation,
  SystemMaintenanceReport,
  SystemOtherAlarmDevices,
  SystemOtherDevices,
  SystemPhoneNumber as SystemPhonenumber,
  SystemPlan,
  SystemPowerUnitsDocumentation,
  SystemSentTextMessagesLogOverlay,
  SystemSettings,
  SystemShareSettings,
    /*SystemQueries, */ SystemShares,
  SystemSpecificationsOverlay,
  SystemTypeDefinitionSubmissionDocuments
};
